module.exports = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};


//# sourceMappingURL=fi-FI.main.js.map
